module.exports = __webpack_public_path__ + "img/illegal_cut_grey_en.cfd18801.svg";